const cineWordMovies = [
  { title: "The Godfather", year: 1972 },
  { title: "The Shawshank Redemption", year: 1994 },
  { title: "Schindler's List", year: 1993 },
  { title: "The Dark Knight", year: 2008 },
  { title: "12 Angry Men", year: 1957 },
  { title: "The Lord of the Rings: The Return of the King", year: 2003 },
  { title: "Pulp Fiction", year: 1994 },
  { title: "The Good, the Bad and the Ugly", year: 1966 },
  { title: "Fight Club", year: 1999 },
  { title: "Forrest Gump", year: 1994 },
  { title: "Inception", year: 2010 },
  { title: "The Lord of the Rings: The Fellowship of the Ring", year: 2001 },
  { title: "Star Wars", year: 1977 },
  { title: "The Matrix", year: 1999 },
  { title: "Goodfellas", year: 1990 },
  { title: "One Flew Over the Cuckoo's Nest", year: 1975 },
  { title: "Seven Samurai", year: 1954 },
  { title: "Se7en", year: 1995 },
  { title: "The Silence of the Lambs", year: 1991 },
  { title: "City of God", year: 2002 },
  { title: "Life Is Beautiful", year: 1997 },
  { title: "It's a Wonderful Life", year: 1946 },
  { title: "Saving Private Ryan", year: 1998 },
  { title: "Interstellar", year: 2014 },
  { title: "The Green Mile", year: 1999 },
  { title: "Parasite", year: 2019 },
  { title: "Léon: The Professional", year: 1994 },
  { title: "Harakiri", year: 1962 },
  { title: "The Pianist", year: 2002 },
  { title: "Gladiator", year: 2000 },
  { title: "American History X", year: 1998 },
  { title: "The Usual Suspects", year: 1995 },
  { title: "The Departed", year: 2006 },
  { title: "The Prestige", year: 2006 },
  { title: "Whiplash", year: 2014 },
  { title: "Casablanca", year: 1942 },
  { title: "The Intouchables", year: 2011 },
  { title: "Modern Times", year: 1936 },
  { title: "Once Upon a Time in the West", year: 1968 },
  { title: "Cinema Paradiso", year: 1988 },
  { title: "Rear Window", year: 1954 },
  { title: "Alien", year: 1979 },
  { title: "Apocalypse Now", year: 1979 },
  { title: "Memento", year: 2000 },
  { title: "Raiders of the Lost Ark", year: 1981 },
  { title: "Django Unchained", year: 2012 },
  { title: "WALL-E", year: 2008 },
  { title: "The Lives of Others", year: 2006 },
  { title: "Sunset Boulevard", year: 1950 },
  { title: "Paths of Glory", year: 1957 },
  { title: "The Shining", year: 1980 },
  { title: "The Great Dictator", year: 1940 },
  { title: "Witness for the Prosecution", year: 1957 },
  { title: "Aliens", year: 1986 },
  { title: "American Beauty", year: 1999 },
  { title: "Dr. Strangelove", year: 1964 },
  { title: "The Dark Knight Rises", year: 2012 },
  { title: "Oldboy", year: 2003 },
  { title: "Amadeus", year: 1984 },
  { title: "Coco", year: 2017 },
  { title: "Toy Story", year: 1995 },
  { title: "Braveheart", year: 1995 },
  { title: "Das Boot", year: 1981 },
  { title: "Avengers: Endgame", year: 2019 },
  { title: "Princess Mononoke", year: 1997 },
  { title: "Joker", year: 2019 },
  { title: "Your Name", year: 2016 },
  { title: "Once Upon a Time in America", year: 1984 },
  { title: "3 Idiots", year: 2009 },
  { title: "Singin' in the Rain", year: 1952 },
  { title: "High and Low", year: 1963 },
  { title: "Capernaum", year: 2018 },
  { title: "Come and See", year: 1985 },
  { title: "Toy Story 3", year: 2010 },
  { title: "Star Wars: The Empire Strikes Back", year: 1980 },
  { title: "Eternal Sunshine of the Spotless Mind", year: 2004 },
  { title: "2001: A Space Odyssey", year: 1968 },
  { title: "Reservoir Dogs", year: 1992 },
  { title: "The Hunt", year: 2012 },
  { title: "Citizen Kane", year: 1941 },
  { title: "Lawrence of Arabia", year: 1962 },
  { title: "M", year: 1931 },
  { title: "North by Northwest", year: 1959 },
  { title: "Vertigo", year: 1958 },
  { title: "Amélie", year: 2001 },
  { title: "A Clockwork Orange", year: 1971 },
  { title: "Full Metal Jacket", year: 1987 },
  { title: "Scarface", year: 1983 },
  { title: "Taxi Driver", year: 1976 },
  { title: "The Sting", year: 1973 },
  { title: "To Kill a Mockingbird", year: 1962 },
  { title: "Up", year: 2009 },
  { title: "Heat", year: 1995 },
  { title: "L.A. Confidential", year: 1997 },
  { title: "Metropolis", year: 1927 },
  { title: "Die Hard", year: 1988 },
  { title: "Snatch", year: 2000 },
  { title: "Bicycle Thieves", year: 1948 },
  { title: "Indiana Jones and the Last Crusade", year: 1989 },
  { title: "1917", year: 2019 },
  { title: "Like Stars on Earth", year: 2007 },
  { title: "Batman Begins", year: 2005 },
  { title: "Downfall", year: 2004 },
  { title: "Dangal", year: 2016 },
  { title: "The Kid", year: 1921 },
  { title: "Some Like It Hot", year: 1959 },
  { title: "The Father", year: 2020 },
  { title: "All About Eve", year: 1950 },
  { title: "Green Book", year: 2018 },
  { title: "The Wolf of Wall Street", year: 2013 },
  { title: "Judgment at Nuremberg", year: 1961 },
  { title: "Casino", year: 1995 },
  { title: "Pan's Labyrinth", year: 2006 },
  { title: "Unforgiven", year: 1992 },
  { title: "The Truman Show", year: 1998 },
  { title: "There Will Be Blood", year: 2007 },
  { title: "The Sixth Sense", year: 1999 },
  { title: "A Beautiful Mind", year: 2001 },
  { title: "Monty Python and the Holy Grail", year: 1975 },
  { title: "Shutter Island", year: 2010 },
  { title: "No Country for Old Men", year: 2007 },
  { title: "The Treasure of the Sierra Madre", year: 1948 },
  { title: "Yojimbo", year: 1961 },
  { title: "The Great Escape", year: 1963 },
  { title: "Rashomon", year: 1950 },
  { title: "Kill Bill: Vol. 1", year: 2003 },
  { title: "The Thing", year: 1982 },
  { title: "Finding Nemo", year: 2003 },
  { title: "The Elephant Man", year: 1980 },
  { title: "Chinatown", year: 1974 },
  { title: "V for Vendetta", year: 2005 },
  { title: "Gone with the Wind", year: 1939 },
  { title: "Inside Out", year: 2015 },
  { title: "Lock, Stock and Two Smoking Barrels", year: 1998 },
  { title: "Raging Bull", year: 1980 },
  { title: "The Secret in Their Eyes", year: 2009 },
  { title: "Howl's Moving Castle", year: 2004 },
  { title: "Three Billboards Outside Ebbing, Missouri", year: 2017 },
  { title: "Prisoners", year: 2013 },
  { title: "Trainspotting", year: 1996 },
  { title: "Gran Torino", year: 2008 },
  { title: "Fargo", year: 1996 },
  { title: "Warrior", year: 2011 },
  { title: "The Bridge on the River Kwai", year: 1957 },
  { title: "Blade Runner", year: 1982 },
  { title: "Catch Me If You Can", year: 2002 },
  { title: "Million Dollar Baby", year: 2004 },
  { title: "My Neighbor Totoro", year: 1988 },
  { title: "Children of Heaven", year: 1997 },
  { title: "The Gold Rush", year: 1925 },
  { title: "Before Sunrise", year: 1995 },
  { title: "12 Years a Slave", year: 2013 },
  { title: "Blade Runner 2049", year: 2017 },
  { title: "On the Waterfront", year: 1954 },
  { title: "The Third Man", year: 1949 },
  { title: "Ben-Hur", year: 1959 },
  { title: "Wild Strawberries", year: 1957 },
  { title: "Gone Girl", year: 2014 },
  { title: "The General", year: 1926 },
  { title: "Harry Potter and the Deathly Hallows: Part 2", year: 2011 },
  { title: "The Deer Hunter", year: 1978 },
  { title: "In the Name of the Father", year: 1993 },
  { title: "The Grand Budapest Hotel", year: 2014 },
  { title: "The Wages of Fear", year: 1953 },
  { title: "Barry Lyndon", year: 1975 },
  { title: "Memories of Murder", year: 2003 },
  { title: "Hacksaw Ridge", year: 2016 },
  { title: "Klaus", year: 2019 },
  { title: "The Seventh Seal", year: 1957 },
  { title: "Room", year: 2015 },
  { title: "Mad Max: Fury Road", year: 2015 },
  { title: "Wild Tales", year: 2014 },
  { title: "The Big Lebowski", year: 1998 },
  { title: "How to Train Your Dragon", year: 2010 },
  { title: "Mary and Max", year: 2009 },
  { title: "Monsters, Inc.", year: 2001 },
  { title: "Jaws", year: 1975 },
  { title: "The Passion of Joan of Arc", year: 1928 },
  { title: "Hotel Rwanda", year: 2004 },
  { title: "Rocky", year: 1976 },
  { title: "Platoon", year: 1986 },
  { title: "Ford v Ferrari", year: 2019 },
  { title: "Dead Poets Society", year: 1989 },
  { title: "The Terminator", year: 1984 },
  { title: "Stand by Me", year: 1986 },
  { title: "Rush", year: 2013 },
  { title: "Network", year: 1976 },
  { title: "Into the Wild", year: 2007 },
  { title: "Logan", year: 2017 },
  { title: "The Wizard of Oz", year: 1939 },
  { title: "Ratatouille", year: 2007 },
  { title: "Groundhog Day", year: 1993 },
  { title: "The Exorcist", year: 1973 },
  { title: "Spotlight", year: 2015 },
  { title: "The Best Years of Our Lives", year: 1946 },
  { title: "The Incredibles", year: 2004 },
  { title: "To Be or Not to Be", year: 1942 },
  { title: "La Haine", year: 1995 },
  { title: "The Battle of Algiers", year: 1966 },
  { title: "Rebecca", year: 1940 },
  { title: "The Grapes of Wrath", year: 1940 },
  { title: "Cool Hand Luke", year: 1967 },
  { title: "Amores Perros", year: 2000 },
  { title: "Pirates of the Caribbean: The Curse of the Black Pearl", year: 2003 },
  { title: "The 400 Blows", year: 1959 },
  { title: "Persona", year: 1966 },
  { title: "Life of Brian", year: 1979 },
  { title: "The Sound of Music", year: 1965 },
  { title: "It Happened One Night", year: 1934 },
  { title: "The Handmaiden", year: 2016 },
  { title: "Dune: Part Two", year: 2024 },
  { title: "Dune", year: 2021 },
  { title: "Oppenheimer", year: 2023 },
  { title: "Everything Everywhere All at Once", year: 2022 },
  { title: "The Banshees of Inisherin", year: 2022 },
  { title: "Aftersun", year: 2022 },
  { title: "Past Lives", year: 2023 },
  { title: "Anatomy of a Fall", year: 2023 },
  { title: "The Holdovers", year: 2023 },
  { title: "Poor Things", year: 2023 },
  { title: "The Zone of Interest", year: 2023 },
  { title: "Perfect Days", year: 2023 },
  { title: "Decision to Leave", year: 2022 },
  { title: "Drive My Car", year: 2021 },
  { title: "The Worst Person in the World", year: 2021 },
  { title: "The Power of the Dog", year: 2021 },
  { title: "Nomadland", year: 2020 },
  { title: "Promising Young Woman", year: 2020 },
  { title: "Sound of Metal", year: 2019 },
  { title: "Portrait of a Lady on Fire", year: 2019 },
  { title: "The Lighthouse", year: 2019 },
  { title: "Uncut Gems", year: 2019 },
  { title: "Marriage Story", year: 2019 },
  { title: "Little Women", year: 2019 },
  { title: "Jojo Rabbit", year: 2019 },
  { title: "Knives Out", year: 2019 },
  { title: "Once Upon a Time in Hollywood", year: 2019 },
  { title: "The Irishman", year: 2019 },
  { title: "Roma", year: 2018 },
  { title: "The Favourite", year: 2018 },
  { title: "Burning", year: 2018 },
  { title: "Shoplifters", year: 2018 },
  { title: "Cold War", year: 2018 },
  { title: "Hereditary", year: 2018 },
  { title: "Phantom Thread", year: 2017 },
  { title: "Call Me by Your Name", year: 2017 },
  { title: "Lady Bird", year: 2017 },
  { title: "Get Out", year: 2017 },
  { title: "Moonlight", year: 2016 },
  { title: "Arrival", year: 2016 },
  { title: "Manchester by the Sea", year: 2016 },
  { title: "La La Land", year: 2016 },
  { title: "The Lobster", year: 2015 },
  { title: "Carol", year: 2015 },
  { title: "Ex Machina", year: 2014 },
  { title: "Nightcrawler", year: 2014 },
  { title: "Birdman", year: 2014 },
  { title: "Boyhood", year: 2014 },
  { title: "Her", year: 2013 },
  { title: "Inside Llewyn Davis", year: 2013 },
  { title: "The Master", year: 2012 },
  { title: "Moonrise Kingdom", year: 2012 },
  { title: "Drive", year: 2011 },
  { title: "A Separation", year: 2011 },
  { title: "The Tree of Life", year: 2011 },
  { title: "Black Swan", year: 2010 },
  { title: "Incendies", year: 2010 },
  { title: "The Social Network", year: 2010 },
  { title: "Inglourious Basterds", year: 2009 },
  { title: "Fantastic Mr. Fox", year: 2009 },
  { title: "A Serious Man", year: 2009 },
  { title: "Coraline", year: 2009 },
  { title: "Slumdog Millionaire", year: 2008 },
  { title: "The Wrestler", year: 2008 },
  { title: "Let the Right One In", year: 2008 },
  { title: "Zodiac", year: 2007 },
  { title: "The Assassination of Jesse James by the Coward Robert Ford", year: 2007 },
  { title: "Children of Men", year: 2006 },
  { title: "Little Miss Sunshine", year: 2006 },
  { title: "Brokeback Mountain", year: 2005 },
  { title: "The New World", year: 2005 },
  { title: "Sin City", year: 2005 },
  { title: "Before Sunset", year: 2004 },
  { title: "Sideways", year: 2004 },
  { title: "Lost in Translation", year: 2003 },
  { title: "Kill Bill: Vol. 2", year: 2004 },
  { title: "Mystic River", year: 2003 },
  { title: "Adaptation.", year: 2002 },
  { title: "Y Tu Mamá También", year: 2001 },
  { title: "Mulholland Drive", year: 2001 },
  { title: "In the Mood for Love", year: 2000 },
  { title: "Requiem for a Dream", year: 2000 },
  { title: "Almost Famous", year: 2000 },
  { title: "Magnolia", year: 1999 },
  { title: "Eyes Wide Shut", year: 1999 },
  { title: "The Thin Red Line", year: 1998 },
  { title: "The Celebration", year: 1998 },
  { title: "Boogie Nights", year: 1997 },
  { title: "The English Patient", year: 1996 },
  { title: "Chungking Express", year: 1994 },
  { title: "Three Colours: Red", year: 1994 },
  { title: "Jurassic Park", year: 1993 },
  { title: "The Piano", year: 1993 },
  { title: "Thelma & Louise", year: 1991 },
  { title: "Edward Scissorhands", year: 1990 },
  { title: "Do the Right Thing", year: 1989 },
  { title: "My Left Foot", year: 1989 },
  { title: "Grave of the Fireflies", year: 1988 },
  { title: "Akira", year: 1988 },
  { title: "The Princess Bride", year: 1987 },
  { title: "Blue Velvet", year: 1986 },
  { title: "Paris, Texas", year: 1984 },
  { title: "Nausicaä of the Valley of the Wind", year: 1984 },
  { title: "The King of Comedy", year: 1982 },
  { title: "E.T. the Extra-Terrestrial", year: 1982 },
  { title: "Possession", year: 1981 },
  { title: "Stalker", year: 1979 },
  { title: "Days of Heaven", year: 1978 },
  { title: "Annie Hall", year: 1977 },
  { title: "Dog Day Afternoon", year: 1975 },
  { title: "The Conversation", year: 1974 },
  { title: "The Long Goodbye", year: 1973 },
  { title: "Solaris", year: 1972 },
  { title: "Aguirre, the Wrath of God", year: 1972 },
  { title: "The French Connection", year: 1971 },
  { title: "The Last Picture Show", year: 1971 },
  { title: "Le Samouraï", year: 1967 },
  { title: "PlayTime", year: 1967 },
  { title: "The Graduate", year: 1967 },
  { title: "Andrei Rublev", year: 1966 },
  { title: "The Umbrellas of Cherbourg", year: 1964 },
  { title: "8½", year: 1963 },
  { title: "Cléo from 5 to 7", year: 1962 },
  { title: "Jules and Jim", year: 1962 },
  { title: "Breathless", year: 1960 },
  { title: "The Apartment", year: 1960 },
  { title: "Hiroshima Mon Amour", year: 1959 },
  { title: "Tokyo Story", year: 1953 },
  { title: "Ikiru", year: 1952 },
  { title: "A Streetcar Named Desire", year: 1951 },
  { title: "The Red Shoes", year: 1948 },
  { title: "Notorious", year: 1946 },
  { title: "Brief Encounter", year: 1945 },
  { title: "Double Indemnity", year: 1944 },
  { title: "The Maltese Falcon", year: 1941 },
  { title: "The Rules of the Game", year: 1939 },
  { title: "Bringing Up Baby", year: 1938 },
  { title: "Sunrise: A Song of Two Humans", year: 1927 },
  { title: "Sherlock Jr.", year: 1924 },
  { title: "Nosferatu", year: 1922 },
  { title: "The Cabinet of Dr. Caligari", year: 1920 },
  { title: "The Florida Project", year: 2017 },
  { title: "First Reformed", year: 2017 },
  { title: "Good Time", year: 2017 },
  { title: "Raw", year: 2016 },
  { title: "The Witch", year: 2015 },
  { title: "Under the Skin", year: 2013 },
  { title: "Enemy", year: 2013 },
  { title: "Take Shelter", year: 2011 },
  { title: "Melancholia", year: 2011 },
  { title: "Dogtooth", year: 2009 },
  { title: "Synecdoche, New York", year: 2008 },
  { title: "The Diving Bell and the Butterfly", year: 2007 },
  { title: "Cache", year: 2005 },
  { title: "2046", year: 2004 },
];

export default cineWordMovies;
